import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import { getMobileAppLanguage } from './utils/mobileAppBridge.ts'

const SUPPORTED_LNGS = ['ca', 'en', 'es', 'fr', 'it']

// Opened from the mobile app's WebView: use the app's language. An explicit
// `lng` makes i18next skip detection; every other visitor keeps the detection
// order below untouched.
const mobileAppLanguage = getMobileAppLanguage(window.location.search, SUPPORTED_LNGS)

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
    debug: false,
    supportedLngs: SUPPORTED_LNGS,
    ...(mobileAppLanguage ? { lng: mobileAppLanguage } : {}),
    nonExplicitSupportedLngs: true,
    // Only base-language files exist (es, en…). Without this, a browser on
    // es-ES / en-GB also requested /locales/es-ES/*.json for every namespace,
    // which the hosting answers with index.html.
    load: 'languageOnly',
    fallbackLng: 'es',
    ns: [
      'auth',
      'tripsList',
      'trip',
      'geo',
      'profile',
      'featuredLocations',
      'mediaManager',
      'preview',
      'checkout',
      'countries',
      'regions',
      'errors',
      'invitations',
      'tripStart',
      'poster',
      'tripbookEditor',
      'tripbookCreation',
      'tripbookReview',
      'account',
      'orders'
    ],
    defaultNS: 'common',
    fallbackNS: 'common',
    interpolation: {
      escapeValue: false
    },
    detection: {
      // The user's saved choice (localStorage) wins over the browser language
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage']
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      // Versioned per deploy so the browser can cache the files between visits
      // (see the /locales headers in firebase.json). Without a build version
      // (local dev) every load fetches fresh copies.
      queryStringParams: { v: import.meta.env.VITE_APP_VERSION || String(Date.now()) }
    }
  })

export default i18n
